import translate from 'utils/apa/translations';
import { getTranslation } from 'utils/getTranslation';

export const MAX_ITEMS_BY_PAGE = 5;

export const MODAL_ERROR = 'ErrorSimple';
export const MODAL_SUCCESS = 'SuccessSimple';

export const getLabels = translations => {
  const before = 'ANTERIOR';
  const next = 'SIGUIENTE';
  const deviceEmpty = getTranslation(
    'profile_my_devices_no_attach',
    translations,
  );
  const historyEmpty = getTranslation(
    'profile_history_no_content',
    translations,
  );
  const title = getTranslation('profile_history_title', translations);
  const subTitle = getTranslation(
    'profile_history_subtitle',
    'Precio',
    translations,
  );
  const price = getTranslation('profile_history_price', 'Precio', translations);
  const currency = getTranslation('currency', translations);
  const expired = getTranslation(
    'profile_history_pruchase_expired',
    translations,
  );
  const add = getTranslation('profile_history_pruchase_from', translations);
  const btnDeviceTitle =
    getTranslation('profile_history_my_devices_title', translations) || 'ver';
  const btnDeviceDesc =
    getTranslation('profile_history_my_devices_desc', translations) || 'ver';
  const btnView =
    getTranslation('profile_history_view_button', translations) || 'ver';
  const btnRenew =
    getTranslation('profile_history_renew', translations) || 'Renovar';
  const btnDownload =
    getTranslation('profile_history_download_button', translations) ||
    'Descargar';
  const btnDevices =
    getTranslation('profile_history_devices_button', translations) ||
    'Dispositivos asociados';
  return {
    title,
    subTitle,
    price,
    currency,
    expired,
    add,
    before,
    next,
    deviceEmpty,
    historyEmpty,
    btnView,
    btnDownload,
    btnRenew,
    btnDevices,
    btnDeviceTitle,
    btnDeviceDesc,
  };
};

export const getMessage = ({ code, message }) => translate(code, message);
